import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (!document.title) {
    document.title = to.meta.title || 'Magic Ticketing';
  }
  next();
});

export default router;
